import Switch from '@mui/material/Switch';
import styled from '@emotion/styled';
import { fontSize, spacing } from 'presentations/views/styles';
import ErrorText from 'presentations/views/components/atoms/ErrorText';
import { memo } from 'react';

interface Props {
  label?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  value?: string | number;
  defaultValue?: string;
  id?: string;
  name?: string;
  onChange?: any;
  isError?: boolean;
  errorText?: string;
  helperText?: string;
  className?: string;
}

const Component = memo((props: Props) => {
  return (
    <>
      <Switch
        className={props.className}
        color="primary"
        checked={props.isChecked}
        disabled={props.isDisabled}
        // size="small"
        value={props.value}
        defaultValue={props.defaultValue}
        id={props.id}
        name={props.name}
        onChange={props.onChange}
      />
      {props.label && <Label>{props.label}</Label>}
      {props.helperText && <HelperText>{props.helperText}</HelperText>}
      {props.isError && props.errorText && (
        <ErrorText>{props.errorText}</ErrorText>
      )}
    </>
  );
});

const Label = styled.span`
  /* font-size: ${fontSize(12)}; */
`;

const HelperText = styled.div`
  font-size: ${fontSize(12)};
  margin-top: ${spacing(4)};
`;

export default Component;
